import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '@app/_core/helper/Utils';
import { LoaderService } from './loader.service';
import { UserService } from './user.service';
import { WebStorageService } from './webstorage.service';
import { AdditionalInfoService } from '@app/_core/services/additional-info.service';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { DialerService } from './dialer.service';

@Injectable({
  providedIn: 'root',
})
export class QueuesService {
  // private queueSource = new BehaviorSubject<string | null>(null);
  // currentQueue = this.queueSource.asObservable();
  //private voiceMailReply = new BehaviorSubject<boolean | null>(null);
  private voiceMailOnSearch = new BehaviorSubject<string | null>(null);
  voiceMailOnSearchContinue = this.voiceMailOnSearch.asObservable();
  TransferType: any;
  VoiceMailDetails: any;
  OutboundUserID: any;
  CaseDetailsLoaded: boolean = false;
  isReadOnlyCase: boolean = false;
  unSubmittedCaseReadOnlyMode: boolean = false;
  setBackToQueueName: any;
  fromSearchQueue: any;
  isParentCheckboxChecked: boolean = true;
  defaultCaseID: any;
  isChildCheckboxChecked: boolean = false;
  transferInteractionID: any = null;
  IsUserChange: any;
  CallIDForTransferCases: string = '';
  InitialChildChkStatus: any = false;
  selectedNewUserId: any = null;
  otherUserCasesForCancelTransfer: any = null;
  recordingStatus: boolean = false;
  constructor(
    private router: Router,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private userService: UserService,
    private additionalinfoService: AdditionalInfoService,
    private flexStore: FlexibleStoreService,
    private dialerService: DialerService,
  ) { }
  isPageInitCompleted: boolean = false;
  isTransferViewActive: boolean = false;
  istransferProcessing: boolean = false;
  isEscalatedCases: boolean = false;
    selectedQueueId: any = '';
    selectedUserID: any;
  conferencelist: any;
  CallID: any = '';
  ChildCallID: any = '';
  InteractionID: any = '';
  TransferCallID: any = '';
  GroupTransferInteractionID: any = '';
  enterRecord: any = null;
  activecallers: any = null;
  CurrentID: number | null = null;
  isFreeDialer: any = null;
  public notify = new BehaviorSubject<any>('');
  public notifyFromTaskMenu = new BehaviorSubject<any>('');
  public selectedTaskMenu = new BehaviorSubject<any>('');
  public CaseDetails_ENABLECONTROLS: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public isTaskMenuQueueSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isInboundCallConnected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public resetSessionTimeout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public handleSessionTimeout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public DisableControls: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public searchParameters: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public VoiceMailNav: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public isNewUser = new BehaviorSubject<any>('');
  public TransferFlag: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  voiceMailReplyQueue = this.VoiceMailNav.asObservable();
  public onWithCaller: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  notifyObservable$ = this.notify.asObservable();
  notifyObservableTaskMenu = this.notifyFromTaskMenu.asObservable();
  selectedTaskMenuQueue = this.selectedTaskMenu.asObservable();
  notifyisNewUser = this.isNewUser.asObservable();
  public notifyEmail = new BehaviorSubject<any>('');
  toEmail = this.notifyEmail.asObservable();
  toEmailArray: any = [];
  filesToSend: any = [];
  selectedSearchRecord: any;
  CurrentTransferData: any;
  markAsRead: boolean = false;
  VoiceMailDetailsReply: boolean = false;
  VoiceMailDetailsReplyForChangeUser: boolean = false;
  queueRoute: string = '';
  public TaskMenuAccordian: any = '';
  selectedCaseOwnerId: number;
  private backClickedSubject = new Subject<number>();
  backClicked$ = this.backClickedSubject.asObservable();
  private toggleUserLabelSource = new Subject<void>();
  toggleUserLabel$ = this.toggleUserLabelSource.asObservable();

  private changeUserLabelSubject = new Subject<void>();
  changeUserLabel$ = this.changeUserLabelSubject.asObservable();
  private elsePartVisibilitySubject = new BehaviorSubject<boolean>(true);
  elsePartVisible$ = this.elsePartVisibilitySubject.asObservable();

  private showUserInfoTabSubject = new BehaviorSubject<boolean>(true);
  showUserInfoTab$ = this.showUserInfoTabSubject.asObservable();
  private emailComposeToSource = new BehaviorSubject<boolean>(false);
  emailComposeTo$ = this.emailComposeToSource.asObservable();
  setEmailComposeTo(value: boolean) 
  {
    this.emailComposeToSource.next(value);
  }
  getEmailComposeToValue(): boolean {
    return this.emailComposeToSource.getValue();
  }
  setInitialChildChkStatus(value) {
    this.InitialChildChkStatus = value;
  }

  GetUnsubmittedCaseForReadonly() {
    return this.unSubmittedCaseReadOnlyMode;
  }
  SetUnsubmittedCaseForReadonly(value) {
    this.unSubmittedCaseReadOnlyMode = value;
  }

  getRecordingStatus(): boolean {
    return this.recordingStatus;
  }

  setRecordingStatus(val) {
    this.recordingStatus = val;
  }


  getSelectedNewUserId(): any {
    return this.selectedNewUserId;
  }

  setSelectedNewUserId(val) {
    this.selectedNewUserId = val;
  }

  getValueParentChk(): boolean {
    return this.isParentCheckboxChecked;
  }

  getDefaultCaseID(): any {
    return this.defaultCaseID
  }

  setDefaultCaseID(value) {
    this.defaultCaseID = value;
  }

  getOtherUserCasesForCancelTransfer(): boolean {
    return this.otherUserCasesForCancelTransfer;
  }

  setOtherUserCasesForCancelTransfer(value) {
    this.otherUserCasesForCancelTransfer = value;
  }

  getValueChildChk(): boolean {
    return this.isChildCheckboxChecked;
  }

  setValueParentChk(value) {
    this.isParentCheckboxChecked = value;
  }

  setValueChildChk(value) {
    this.isChildCheckboxChecked = value;
  }

  setTransferInteractionID(value){
    this.transferInteractionID = value;
  }
  getTransferInteractionID() : any {
    return this.transferInteractionID;
  }

  setFromSearchQueue(value) {
    this.fromSearchQueue = value;

  }
  getFromSearchQueue() {
    return this.fromSearchQueue;
  }
  showUserInfoTab() {
    this.showUserInfoTabSubject.next(true);
  }

  hideUserInfoTab() {
    this.showUserInfoTabSubject.next(false);
  }

  hideElsePart() {
    this.elsePartVisibilitySubject.next(false);
  }
  setTransferFlag(flag) {
    this.TransferFlag.next(flag);
  }

  showElsePart() {
    this.elsePartVisibilitySubject.next(true);
  }

  triggerChangeUserLabel() {
    this.changeUserLabelSubject.next();
  }

  triggerBackClicked(value: number) {
    this.backClickedSubject.next(value);
  }

  triggerToggleUserLabel() {
    this.toggleUserLabelSource.next();
  }

  setSearchParameters(data: any) {
    this.searchParameters.next(data);
  }
  resetsSessionTimeout(data: any) {
    this.resetSessionTimeout.next(data);
  }
  handlesSessionTimeout(data: any) {
    this.handleSessionTimeout.next(data);
  }
  setIsNewUser(data: any) {
    if (data) {
        this.isNewUser.next(data);
    }
  }
  getselectedQueueId() {
    return this.selectedQueueId;
  }
    getselectedUserID() {
        return this.selectedUserID;
    }
    setselectedUserID(value) {
        this.selectedUserID = value;
    }
  setSelectedSearchRecord(value) {
    this.selectedSearchRecord = value;
  }
  getSelectedSearchRecord() {
    if (this.selectedSearchRecord && this.selectedSearchRecord.length > 0) {
      return this.selectedSearchRecord[0];
    }
    return null;
  }
  setselectedQueueId(value) {
    this.selectedQueueId = value;
  }
  getactivecallers() {
    return this.activecallers;
  }
  setactivecallers(val: any) {
    this.activecallers = val;
  }
  getisTransferViewActive() {
    return this.isTransferViewActive;
  }
  setisTransferViewActive(val: boolean) {
    this.isTransferViewActive = val;
  }

  getistransferProcessing() {
    return this.istransferProcessing;
  }
  setistransferProcessing(val: boolean) {
    this.istransferProcessing = val;
  }
  getconferencelist() {
    return this.conferencelist;
  }
  setconferencelist(val: any) {
    this.conferencelist = val;
  }
  getIsPageLoadCompleted() {
    return this.isPageInitCompleted;
  }
  setIsPageLoadCompleted(val: boolean) {
    this.isPageInitCompleted = val;
  }

  getEnterRecordTime() {
    return this.enterRecord;
  }

  setEnterRecordTime(value) {
    this.enterRecord = value;
  }

  getIsUserChange() {
    return this.IsUserChange;
  }

  setIsUserChange(value) {
    this.IsUserChange = value;
  }

  getCurrentTransferData() {
    return this.CurrentTransferData;
  }

  setCurrentTransferData(value) {
    this.CurrentTransferData = value;
  }
  getCallID() {
    return this.CallID;
  }

  setCallID(value) {
    //console.log('setcallid:', value);
    this.CallID = value;
  }
  getChildCallID() {
        return this.ChildCallID;
  }

  setChildCallID(value) {
        //console.log('setChildcallid:', value);
      this.ChildCallID = value;
  }
  setOnWithCaller(value) {
    this.onWithCaller.next(value);
  }
  getInteractionID() {
    return this.InteractionID;
  }
  setInteractionID(value) {
    this.InteractionID = value;
  }
  getTransferCallID() {
    return this.TransferCallID;
  }
  setTransferCallID(value) {
    this.TransferCallID = value;
  }
  setGroupTransferInteractionID(value) {
    this.GroupTransferInteractionID = value;
  }
  getGroupTransferInteractionID() {
    return this.GroupTransferInteractionID;
  }
  notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }
  notifyOtherFromTaskMenu(data: any) {
    if (data) {
      this.notifyFromTaskMenu.next(data);
    }
  }
  SetTaskSelectedQueue(data: any) {
    if (data) {
      this.selectedTaskMenu.next(data);
    }
  }
  setCaseDetails_ENABLECONTROLS(value: any) {
    //console.log(value, 'Value');
    this.CaseDetails_ENABLECONTROLS.next(value);
  }
  toAddEmailArrayFunction(data: any): any {
    this.toEmailArray.push(data);
    this.notifyEmail.next([...this.toEmailArray]);
  }
  toSubEmailArrayFunction(data: any): any {
    const index = this.toEmailArray.indexOf(data, 0);
    if (index > -1) {
      this.toEmailArray.splice(index, 1);
    }
    this.notifyEmail.next([...this.toEmailArray]);
    // console.log(this.toEmailArray);
  }
  toGetEmailArrayFunction(): any {
    return this.toEmailArray;
  }
  setTaskMenuQueueSelected(data: any) {
    this.isTaskMenuQueueSelected.next(data);
  }

  setisInboundCallConnected(data: any) {
    this.isInboundCallConnected.next(data);
  }
  setUserDetails(data: any) {
    let pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.capResults = true;
    pl.company = company;
    pl = { ...pl, ...data };
    return pl;
  }

  GetSearchParams(): any {
    let pl: any = {};
    pl = this.setUserDetails(pl);
    // console.log("pl",pl)
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetSearchParams`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  handleError(errorResponse: HttpErrorResponse) {
    this?.dialerService?.setIsBlockLoader(false);
    return Utils.handleHttpError(errorResponse);
  }

  getCaseForUser(details: any) {
    let userID;
    if (Array.isArray(details)) {
      userID = details[0].UserID;
    } else {
      userID = details.UserID;
    }
    let pl: any = {};
    pl = this.setUserDetails(pl);
    pl.userID = userID;
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCaseForUser`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }
  getCaseID(id: any) {
    let company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.get(`${environment.apiUrl}api/service/data/GetCaseID?searchID=${id}&company=${company}`).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  getCaseDetails(value: any, details: any): any {
    // let queues:any=[];
    // let queueId:any;
    // return this.tmqueueService.getQueues().pipe(map((data: any) => {
    //     queues= data.Response.Data;
    //     let fp=value.menu;
    //     queues.forEach((ele)=>{
    //       if(ele.Type===fp)
    //         queueId=ele.ID
    //     })
    //console.log(details);
    let userID, caseID, activityId, actionItemIDArr;

    if (Array.isArray(details)) {
      userID = details[0].UserID;
      caseID = details[0].CaseID;
      actionItemIDArr = details[0].ActionItemID.split('-');
      activityId = actionItemIDArr;
    } else {
      userID = details.UserID;
      caseID = details.CaseID;
      actionItemIDArr = details.ActionItemID.split('-');
      activityId = actionItemIDArr[0];
    }

    // console.log(activityId + '-' + userID + '-' + caseID);
    return activityId + '-' + userID + '-' + caseID;

    //another api call GetCaseForUser
    // this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
    // }
    //   ),
    //   catchError((error) => {

    //     return EMPTY;
    //   })
    // )
  }

  getQueueColumns(queueID): any {
    let pl: any = {};
    pl = this.setUserDetails(pl);
    pl.queueID = queueID;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetQueueColumns`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  getCases(
    userId: any,
    caseId: any,
    queueId: any,
    pageNumber: number,
    caseSearchText: any,
    pageSize: any,
    statusValue: any,
    priorityValue: any,
    isMultipleUser: boolean = false,
    OtherUserCaseIds: any = null,
    NewUserCases: any[] = [],
    isEmptyCallID = false
  ): any {
    let pl: any = {};
    pl = this.setUserDetails(pl);
    pl.userID = userId;
    pl.caseID = caseId;
    pl.queueId = queueId;
    pl.caseStatusTypeID = statusValue;
    pl.casePriorityID = priorityValue;
    pl.page = pageNumber;
    pl.pageSize = pageSize;
    pl.caseSearchText = caseSearchText;
    pl.company= this.webStorageService.getItemFromSessionStorage('company');
    pl.MultipleUser = isMultipleUser;
    pl.OtherUserCaseIds = OtherUserCaseIds;
    pl.NewUserCases = NewUserCases;
    // this.loaderService.display(true);
    let isChildChecked = this.getValueChildChk();
    if(this.InitialChildChkStatus || isChildChecked){
      if(this.CallID){
        pl.CallID = this.CallID
      }else{
        pl.CallID = this.CallIDForTransferCases
      }
    }else{
      pl.CallID = '';
    }
    
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCases`, pl).pipe(
      map(res => {
        this?.dialerService?.setIsBlockLoader(false);
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
    // caseID: 141
    // casePriorityID: null
    // caseSearchText: ""
    // caseStatusTypeID: 1
    // csrfCookie: "4227E84FAFD3319F3603086C79B63A926928939E"
    // page: 1
    // pageSize: 15
    // userID: 4

    // return {
    //     "Response": {
    //         "Data": {
    //             "UserID": 4,
    //             "CaseID": 141,
    //             "CaseCount": 11,
    //             "PageCount": 1,
    //             "Cases": [
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 141,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Closed",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1660769251242)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1660769251226)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 380,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Closed",
    //                     "Priority": "Low",
    //                     "Opened": "\/Date(1695110707074)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1695110707130)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 379,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Responded",
    //                     "Priority": "High",
    //                     "Opened": "\/Date(1695110644810)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1695110644860)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 378,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1695110640951)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1695110641000)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 377,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1695110599608)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1695110599656)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 376,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1695110593092)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1695110593156)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 140,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1660769165960)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1660769165940)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 57,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1659710446111)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1659710446090)\/",
    //                     "Category": null,
    //                     "AllowDelete": false
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 36,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1659098952721)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1659098952670)\/",
    //                     "Category": null,
    //                     "AllowDelete": false
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 35,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1659098690580)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1659098690526)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 },
    //                 {
    //                     "ContactName": null,
    //                     "PhoneNumbers": null,
    //                     "Company": null,
    //                     "Address": null,
    //                     "LastUpdated": "\/Date(-62135578800000)\/",
    //                     "EmailID": null,
    //                     "CreatedBy": null,
    //                     "Creator": null,
    //                     "RelatedUsers": null,
    //                     "CaseItems": null,
    //                     "Attributes": {},
    //                     "CaseID": 33,
    //                     "CaseStatusID": 1,
    //                     "CaseStatusTypeID": 1,
    //                     "CasePriorityID": 2,
    //                     "UserID": 4,
    //                     "Status": "Open",
    //                     "StatusType": "Open",
    //                     "Priority": "Normal",
    //                     "Opened": "\/Date(1659097807547)\/",
    //                     "Closed": null,
    //                     "CrmCaseID": null,
    //                     "Created": "\/Date(1659097807513)\/",
    //                     "Category": null,
    //                     "AllowDelete": true
    //                 }
    //             ],
    //             "Page": 1,
    //             "RangeStart": 1,
    //             "RangeEnd": 11
    //         },
    //         "Status": 1,
    //         "Message": null
    //     },
    //     "Status": 1,
    //     "Message": null
    // }
  }
 
  getCasesDetails(caseId): any {
    let pl: any = {};
    pl = this.setUserDetails(pl);
    pl.id = caseId;
    pl.addUserAsPrimary = false;
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCaseDetails`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
    // return {
    //     "Response": {
    //         "Data": {
    //             "ContactName": null,
    //             "PhoneNumbers": [],
    //             "Company": null,
    //             "Address": null,
    //             "LastUpdated": "\/Date(1664732126236)\/",
    //             "EmailID": null,
    //             "CreatedBy": 22,
    //             "Creator": {
    //                 "Email": "nina.duffy@cognizant.com",
    //                 "FirstName": "Nina",
    //                 "LastName": "Duffy",
    //                 "ID": 22,
    //                 "Name": "Nina Duffy",
    //                 "Group": null,
    //                 "UseSoftPhone": true,
    //                 "Phone": null,
    //                 "Extension": null,
    //                 "Avatar": null
    //             },
    //             "RelatedUsers": {},
    //             "CaseItems": {},
    //             "Attributes": {
    //                 "CallersName": "Antonio",
    //                 "CallersTitle": "",
    //                 "Case number (Ticket Number)": "1",
    //                 "Case Priority": "Low",
    //                 "Case Status": "Closed",
    //                 "EscalationType": "SME",
    //                 "Escalation Comments": "TEST",
    //                 "Resolution Comments": "TEST",
    //                 "CreatorID": "22",
    //                 "CreatorName": "Nina Duffy",
    //                 "CreatorFirstName": "Nina",
    //                 "CreatorLastName": "Duffy",
    //                 "CreatorGroup": null,
    //                 "CreatorEmail": "nina.duffy@cognizant.com",
    //                 "CreatorUseSoftPhone": "True",
    //                 "CreatorPhone": null,
    //                 "CreatorExtension": null,
    //                 "CreatorAvatar": null
    //             },
    //             "CaseID": 57,
    //             "CaseStatusID": 1,
    //             "CaseStatusTypeID": 1,
    //             "CasePriorityID": 2,
    //             "UserID": 4,
    //             "Status": "Open",
    //             "StatusType": "Open",
    //             "Priority": "Normal",
    //             "Opened": "\/Date(1659710446111)\/",
    //             "Closed": null,
    //             "CrmCaseID": null,
    //             "Created": "\/Date(1659710446090)\/",
    //             "Category": null,
    //             "AllowDelete": false
    //         },
    //         "Status": 1,
    //         "Message": null
    //     },
    //     "Status": 1,
    //     "Message": null
    // }
  }
  deleteCase(id): any {
    let pl: any = {};
      pl.id = id;
      pl.company = this.webStorageService.getItemFromSessionStorage('company');
    //return this.http.delete<any>(`${environment.apiUrl}api/service/data/DeleteCase?id=${id}`).pipe(
    // return this.http.post<any>(`${environment.apiUrl}api/service/data/DeleteCase/${id}`, pl).pipe(
    return this.http.post<any>(`${environment.apiUrl}api/service/data/DeleteCase`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getUserDetails(caseId: any, userId: any): any {
    //request body
    //     {
    //     "userID": 4,
    //     "caseID": 141,
    //     "caseUserRoleID": null,
    //     "csrfCookie": "7138AA25411BFF52C701EDA31032D385C24F89DD"
    // }

    // console.log(this.router.url)

    //  console.log('getUserDetails caseId', caseId);
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.user = user;
    pl.userID = Number(userId);
    pl.caseID = Number(caseId);
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    pl.caseUserRoleID = null;
    pl.user = user;
    this.selectedCaseOwnerId = pl.userID;
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetUserDetail`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );

    // return {
    //     "Response": {
    //         "Data": {
    //             "CustomResponses": {},
    //             "UserID": 4,
    //             "FirstName": "Antonio",
    //             "LastName": "Rubin",
    //             "FullName": "Antonio Rubin",
    //             "DateOfBirth": null,
    //             "EmailAddress": "antonio.rubin@cognizant.com",
    //             "JobTitle": null,
    //             "Industry": "Other",
    //             "JobLevel": null,
    //             "ActivityGroup": null,
    //             "Role": "Other",
    //             "Company": null,
    //             "CompanyType": null,
    //             "Address1": null,
    //             "Address2": null,
    //             "City": "Bangalore",
    //             "Country": "UNITED STATES",
    //             "State": "FLORIDA",
    //             "StateAbbrev": "FL",
    //             "Zip": null,
    //             "PostalCode": null,
    //             "Score": 320,
    //             "VanityID": "AntonioRubin18480",
    //             "ShortVanityID": null,
    //             "CrmUserID": "8675309",
    //             "PromptResponses": null,
    //             "RequestType": null,
    //             "PhoneNumbers": [
    //                 {
    //                     "PhoneNumberID": 8,
    //                     "Number": "2036105887",
    //                     "StrippedNumber": "2036105887",
    //                     "Type": "Business"
    //                 },
    //                 {
    //                     "PhoneNumberID": 39,
    //                     "Number": "4322018925",
    //                     "StrippedNumber": "4322018925",
    //                     "Type": "Business"
    //                 }
    //             ],
    //             "LastDisposition": null,
    //             "DispositionGroup": null,
    //             "Owner": null,
    //             "FollowUpDate": null,
    //             "FollowUpType": null,
    //             "LastCalled": null,
    //             "FirstResponseSourceName": null,
    //             "FirstResponseDate": null,
    //             "Department": null,
    //             "IsOverview": false,
    //             "ActionItemID": null,
    //             "Grouping": null,
    //             "Priority": null,
    //             "LockingUserID": null,
    //             "WaitTime": null,
    //             "CallType": null,
    //             "CaseID": 141,
    //             "CrmCaseID": null,
    //             "CaseStatus": "Open",
    //             "CasePriority": "Normal",
    //             "CaseOpened": "\/Date(1660769251242)\/",
    //             "CaseClosed": null,
    //             "SourceSystem": "Onvida",
    //             "SurveyResponses": [
    //                 {
    //                     "FieldName": "CompanySize",
    //                     "Label": "How large is your company in terms of annual revenue?",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "TopicsInterest",
    //                     "Label": "What topics are of most interest to you? (Check all that apply.)",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 }
    //             ],
    //             "UserInfoResponses": [
    //                 {
    //                     "FieldName": "CrmUserID",
    //                     "Label": "Employee ID:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "OT",
    //                     "Label": "OT",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Designation",
    //                     "Label": "Designation",
    //                     "Points": 0,
    //                     "Values": [
    //                         "Director"
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "GradeBand",
    //                     "Label": "Grade Band:",
    //                     "Points": 0,
    //                     "Values": [
    //                         "TL1"
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Phone",
    //                     "Label": "Contact Number",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Zip",
    //                     "Label": "Postal Code",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Reporting Manager Employee ID",
    //                     "Label": "Reporting Manager Employee ID:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Reporting Manager First Name",
    //                     "Label": "Reporting Manager First Name:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Reporting Manager Last Name",
    //                     "Label": "Reporting Manager Last Name:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Reporting Manager Email Address",
    //                     "Label": "Reporting Manager Email Address:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Reporting Manager Contact Number",
    //                     "Label": "Reporting Manager Contact Number:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Organization Name",
    //                     "Label": "Organization Name:",
    //                     "Points": 0,
    //                     "Values": [
    //                         ""
    //                     ],
    //                     "Comments": []
    //                 },
    //                 {
    //                     "FieldName": "Department or Divison",
    //                     "Label": "Department or Divison:",
    //                     "Points": 0,
    //                     "Values": [
    //                         "Marketing"
    //                     ],
    //                     "Comments": []
    //                 }
    //             ],
    //             "SearchableFieldResponses": [],
    //             "Cases": [],
    //             "UserRelationships": []
    //         },
    //         "Status": 1,
    //         "Message": null
    //     },
    //     "Status": 1,
    //     "Message": null
    // }
  }

  getDialSections(activityId: any): any {
    //let pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const payload = { user: user, company: company, activityId: activityId };

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetDialogSections`, payload).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
    // return {
    //     "Response": {
    //         "Data": [
    //             {
    //                 "DialogSectionID": 1,
    //                 "Name": "UserInfo",
    //                 "Label": "User Information",
    //                 "Enabled": true,
    //                 "DisplayOrder": 1
    //             },
    //             {
    //                 "DialogSectionID": 2,
    //                 "Name": "Cases",
    //                 "Label": "Cases",
    //                 "Enabled": true,
    //                 "DisplayOrder": 2
    //             },
    //             {
    //                 "DialogSectionID": 4,
    //                 "Name": "Disposition",
    //                 "Label": "Disposition",
    //                 "Enabled": true,
    //                 "DisplayOrder": 4
    //             }
    //         ],
    //         "Status": 1,
    //         "Message": null
    //     },
    //     "Status": 1,
    //     "Message": null
    // }
  }

  findRecord(data: any, searchType: any = 'user', closeLoader: boolean = true, IsDefaultCaseReadOnly: boolean = false ): any {
    const company = this.webStorageService.getItemFromSessionStorage('company');
    
    let pl: any = {};
    pl = this.setUserDetails(pl);
    pl.searchParams = data;
    pl.agentsOnly = searchType == 'agent';
    pl.company = company;
    pl.isDefaultCaseReadOnly = IsDefaultCaseReadOnly;

    //console.log("pl", pl)
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/FindRecord`, pl).pipe(
      map(res => {
        //if(closeLoader || res.Response.Data.length<=0){
        this.loaderService.display(false);
        if (Array.isArray(res?.Response?.Data)) {
          res.Response.Data.forEach((item: any) => {
            item.Company = Utils.GetDecodedString(item.Company);
          });
        }
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
    // return{
    //     "Response": {
    //         "Data": [
    //             {
    //                 "CustomResponses": {},
    //                 "UserID": 4,
    //                 "FirstName": "Antonio",
    //                 "LastName": "Rubin",
    //                 "FullName": "Antonio Rubin",
    //                 "DateOfBirth": null,
    //                 "EmailAddress": "antonio.rubin@cognizant.com",
    //                 "JobTitle": null,
    //                 "Industry": "Other",
    //                 "JobLevel": null,
    //                 "ActivityGroup": null,
    //                 "Role": "Other",
    //                 "Company": null,
    //                 "CompanyType": null,
    //                 "Address1": null,
    //                 "Address2": null,
    //                 "City": "Bangalore",
    //                 "Country": "UNITED STATES",
    //                 "State": "FLORIDA",
    //                 "StateAbbrev": "FL",
    //                 "Zip": null,
    //                 "PostalCode": null,
    //                 "Score": 320,
    //                 "VanityID": "AntonioRubin18480",
    //                 "ShortVanityID": null,
    //                 "CrmUserID": "8675309",
    //                 "PromptResponses": null,
    //                 "RequestType": null,
    //                 "PhoneNumbers": [
    //                     {
    //                         "PhoneNumberID": 8,
    //                         "Number": "2036105887",
    //                         "StrippedNumber": "2036105887",
    //                         "Type": "Business"
    //                     },
    //                     {
    //                         "PhoneNumberID": 39,
    //                         "Number": "4322018925",
    //                         "StrippedNumber": "4322018925",
    //                         "Type": "Business"
    //                     }
    //                 ],
    //                 "LastDisposition": null,
    //                 "DispositionGroup": null,
    //                 "Owner": null,
    //                 "FollowUpDate": null,
    //                 "FollowUpType": null,
    //                 "LastCalled": null,
    //                 "FirstResponseSourceName": null,
    //                 "FirstResponseDate": null,
    //                 "Department": null,
    //                 "IsOverview": false,
    //                 "ActionItemID": null,
    //                 "Grouping": null,
    //                 "Priority": null,
    //                 "LockingUserID": null,
    //                 "WaitTime": null,
    //                 "CallType": null,
    //                 "CaseID": null,
    //                 "CrmCaseID": null,
    //                 "CaseStatus": null,
    //                 "CasePriority": null,
    //                 "CaseOpened": null,
    //                 "CaseClosed": null,
    //                 "SourceSystem": "Onvida",
    //                 "SurveyResponses": [],
    //                 "UserInfoResponses": [],
    //                 "SearchableFieldResponses": [],
    //                 "Cases": [],
    //                 "UserRelationships": []
    //             },
    // {
    //                 "CustomResponses": {},
    //                 "UserID": 22,
    //                 "FirstName": "Nina",
    //                 "LastName": "Duffy",
    //                 "FullName": "Nina Duffy",
    //                 "DateOfBirth": null,
    //                 "EmailAddress": "nina.duffy@cognizant.com",
    //                 "JobTitle": null,
    //                 "Industry": "Other",
    //                 "JobLevel": null,
    //                 "ActivityGroup": null,
    //                 "Role": "Other",
    //                 "Company": null,
    //                 "CompanyType": null,
    //                 "Address1": null,
    //                 "Address2": null,
    //                 "City": "aaaaa",
    //                 "Country": "INDIA",
    //                 "State": "JHARKHAND",
    //                 "StateAbbrev": "JH",
    //                 "Zip": null,
    //                 "PostalCode": null,
    //                 "Score": 0,
    //                 "VanityID": "NinaDuffy75216",
    //                 "ShortVanityID": null,
    //                 "CrmUserID": "JennyJenny",
    //                 "PromptResponses": null,
    //                 "RequestType": null,
    //                 "PhoneNumbers": [],
    //                 "LastDisposition": null,
    //                 "DispositionGroup": null,
    //                 "Owner": null,
    //                 "FollowUpDate": null,
    //                 "FollowUpType": null,
    //                 "LastCalled": null,
    //                 "FirstResponseSourceName": null,
    //                 "FirstResponseDate": null,
    //                 "Department": null,
    //                 "IsOverview": false,
    //                 "ActionItemID": null,
    //                 "Grouping": null,
    //                 "Priority": null,
    //                 "LockingUserID": null,
    //                 "WaitTime": null,
    //                 "CallType": null,
    //                 "CaseID": null,
    //                 "CrmCaseID": null,
    //                 "CaseStatus": null,
    //                 "CasePriority": null,
    //                 "CaseOpened": null,
    //                 "CaseClosed": null,
    //                 "SourceSystem": "Onvida",
    //                 "SurveyResponses": [],
    //                 "UserInfoResponses": [],
    //                 "SearchableFieldResponses": [],
    //                 "Cases": [],
    //                 "UserRelationships": []
    //             }
    //         ],
    //         "Status": 1,
    //         "Message": null
    //     },
    //     "Status": 1,
    //     "Message": null
    // }
  }

  GetActionItemPage(queueID): any {
    let pl: any = {
      rowOffset: 0,
      rowCount: 200,
      searchValue: '',
      filterDict: null,
      sortColumn: 'ID',
      sortDescend: false,
      queueID: queueID,
      displayType: 0,
      priorityFilter: -1,
      filterOptionRequestColumn: null,
    };

    pl = this.setUserDetails(pl);
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetActionItemPage`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        if (Array.isArray(res?.Response?.Data.Items)) {
          res.Response.Data.Items.forEach((item: any) => {
            item.Company = Utils.GetDecodedString(item.Company);
          });
        }
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  dynamicGetActionItemPage(param: any): any {
    let pl: any = {
      rowOffset: param.rowOffset || 0,
      rowCount: param.rowCount || 200,
      searchValue: param.searchValue || '',
      filterDict: param.filterDict || null,
      sortColumn: param.sortColumn || 'ID',
      sortDescend: param.sortDescend || false,
      queueID: param.queueID || null,
      displayType: 0,
      priorityFilter: -1,
      filterOptionRequestColumn: param.filterOptionRequestColumn || null,
    };

    pl = this.setUserDetails(pl);
    this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetActionItemPage`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        if (Array.isArray(res?.Response?.Data.Items)) {
          res.Response.Data.Items.forEach((item: any) => {
            item.Company = Utils.GetDecodedString(item.Company);
          });
        }
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  getEmptyCase(data): any {
    // let pl: any = {
    //   addUserAsPrimary: false
    // };

    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/Data/CreateEmptyCase`, data).pipe(
      map(res => {
        // console.log(res);

        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );

    //no need of this when api gets called
    const currentdate = new Date();
    const datetime =
      currentdate.getDate() +
      '/' +
      (currentdate.getMonth() + 1) +
      '/' +
      currentdate.getFullYear() +
      ' ' +
      currentdate.getHours() +
      ':' +
      currentdate.getMinutes() +
      ':' +
      currentdate.getSeconds() +
      ' PM';
    //console.log(datetime);
    //     payload
    // addUserAsPrimary: false
    // csrfCookie: "9F1275F983D38F0A10A3A5F96046776F6C6E4057"
    return {
      Response: {
        Data: {
          ContactName: null,
          PhoneNumbers: [],
          Company: null,
          Address: null,
          LastUpdated: datetime,
          // "\/Date(-62135578800000)\/",
          EmailID: null,
          CreatedBy: 1229,
          Creator: null,
          RelatedUsers: {},
          CaseItems: {},
          Attributes: {},
          CaseID: 389,
          CaseStatusID: 1,
          CaseStatusTypeID: 1,
          CasePriorityID: 2,
          UserID: 4,
          Status: 'Open',
          StatusType: 'Open',
          Priority: 'Normal',
          Opened: datetime,
          // "\/Date(1695656212573)\/",
          Closed: null,
          CrmCaseID: null,
          Created: datetime,
          // "\/Date(1695656212613)\/",
          Category: null,
          AllowDelete: true,
        },
        Status: 1,
        Message: null,
      },
      Status: 1,
      Message: null,
    };
  }

  getCaseChangeSets(caseID: number): any {
    let pl: any = {
      caseID: caseID,
    };

    pl = this.setUserDetails(pl);
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCaseChangeSets`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
    // caseID: 57
    // csrfCookie: "3937234E061A449247BB7E7F03A01F7EB3650043"

    return {
      Response: {
        Data: [
          // {
          //     "CaseID": 57,
          //     "InteractionID": 4169,
          //     "UserID": 4,
          //     "User": {
          //         "Email": "antonio.rubin@cognizant.com",
          //         "FirstName": "Antonio",
          //         "LastName": "Rubin",
          //         "ID": 4,
          //         "Name": "Antonio Rubin",
          //         "Group": null,
          //         "UseSoftPhone": true,
          //         "Phone": null,
          //         "Extension": null,
          //         "Avatar": null
          //     },
          //     "Date": "\/Date(1664732126300)\/",
          //     "Changes": [
          //         {
          //             "ID": 212,
          //             "CaseID": 57,
          //             "InteractionID": 4169,
          //             "UserID": 4,
          //             "Field": "Escalation Comments",
          //             "PreviousValue": null,
          //             "Value": "TEST",
          //             "Date": "\/Date(1664732126300)\/"
          //         },
          //         {
          //             "ID": 213,
          //             "CaseID": 57,
          //             "InteractionID": 4169,
          //             "UserID": 4,
          //             "Field": "Resolution Comments",
          //             "PreviousValue": null,
          //             "Value": "TEST",
          //             "Date": "\/Date(1664732126300)\/"
          //         }
          //     ]
          // },
          // {
          //     "CaseID": 57,
          //     "InteractionID": 2732,
          //     "UserID": 4,
          //     "User": {
          //         "Email": "antonio.rubin@cognizant.com",
          //         "FirstName": "Antonio",
          //         "LastName": "Rubin",
          //         "ID": 4,
          //         "Name": "Antonio Rubin",
          //         "Group": null,
          //         "UseSoftPhone": true,
          //         "Phone": null,
          //         "Extension": null,
          //         "Avatar": null
          //     },
          //     "Date": "\/Date(1660737163976)\/",
          //     "Changes": [
          //         {
          //             "ID": 47,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "CallersName",
          //             "PreviousValue": null,
          //             "Value": "Antonio",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 48,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "CallersTitle",
          //             "PreviousValue": null,
          //             "Value": "",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 49,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "Case number (Ticket Number)",
          //             "PreviousValue": null,
          //             "Value": "1",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 50,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "Case Priority",
          //             "PreviousValue": null,
          //             "Value": "Low",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 51,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "Case Status",
          //             "PreviousValue": null,
          //             "Value": "Closed",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 52,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "EscalationType",
          //             "PreviousValue": null,
          //             "Value": "SME",
          //             "Date": "\/Date(1660737163976)\/"
          //         },
          //         {
          //             "ID": 53,
          //             "CaseID": 57,
          //             "InteractionID": 2732,
          //             "UserID": 4,
          //             "Field": "Opened",
          //             "PreviousValue": "8/5/2022 10:40:46 AM",
          //             "Value": "8/5/2022 10:40:46 AM",
          //             "Date": "\/Date(1660737163976)\/"
          //         }
          //     ]
          // }
        ],
        Status: 1,
        Message: null,
      },
      Status: 1,
      Message: null,
    };
  }

  getCallHistory(UserID: any, page: number, callID: any,filterDict: any[] = []) {
    let pl: any = {
      UserID: UserID,
      page: page,
      callID: callID,
      filterDict: filterDict
    };

    pl = this.setUserDetails(pl);
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCallHistory`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }

  getScript(userId: any, caseID: any, activityId: any) {
    let pl: any = {
      userId: userId,
      caseID: caseID,
      activityId: activityId,
    };

    pl = this.setUserDetails(pl);
    // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetScript`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }
  getDynamicUserInfoHTML(): any {
    // this.loaderService.display(true);

    return this.http
      .get(`${environment.apiUrl}api/home/PrepareHtmlContent?ExperienceTypeID=16&ActivityID=22`, {
        responseType: 'text',
      })
      .pipe(
        map(res => {
          this.loaderService.display(false);
          // console.log(res);
          return res;
        }),
        catchError(Utils.handleHttpError)
      );
  }

  executeScript(js: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = js;
    document.body.appendChild(script);
  }

  getFieldDetails(): any {
    // this.loaderService.display(true);

    return this.http.get(`${environment.apiUrl}api/home/PrepareDynamicViewDefinition`, { responseType: 'text' }).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
    getInboundNumber(interactionID: any): any {
        const company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http
        .get(`${environment.apiUrl}api/interaction/GetInboundPhoneNumber?interactionID=${interactionID}&company=${ company }`)
      .pipe(
        map(res => {
          this.loaderService.display(false);
          return res;
        }),
        catchError(Utils.handleHttpError)
      );
  }

  GetCompositionData(): any {
    const pl: any = {};
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    // this.loaderService.display(true);

    return this.http.post(`${environment.apiUrl}api/service/fax/GetCompositionData`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  SendFax(data: any) {
    const formData = new FormData();
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');

    formData.append('to', data.to);
    formData.append('from', data.from);
    formData.append('headerText', data.headerText);
    formData.append('coverPage', data.coverPage);
    formData.append('content', data.Content === undefined ? '' : data.Content);
    const userID = this.selectedCaseOwnerId;
    // console.log(data.files[0].file);
    // Array.from(data.files).forEach((file, index) => {
    //   formData.append('file${index}', file as Blob);
    // });

    // this.filesToSend.forEach((file, index) => {
    //   formData.append('file[]', file);
    // });

    // data.files.forEach(file => {
    //   this.filesToSend.push({ file: file });
    // });

    //console.log(this.filesToSend);
    // this.filesToSend.forEach(file => {
    //   formData.append('file[]', file);
    // });

    //this.filesToSend = data.files;
    //formData.append('file', data.files[0]);
    formData.append('company', company);
    formData.append('user', JSON.stringify(user));
    formData.append('userID', userID.toString());
    for (let i = 0; i < data.files.length; i++) {
      formData.append('file', data.files[i]);
    }
    // console.log(formData);
    //let pl: any = {};
    //pl = this.setUserDetails(data);
    //pl = JSON.parse(JSON.stringify(pl));
    // pl.company = this.webStorageService.getItemFromSessionStorage('company');
    // pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');

    // this.loaderService.display(true);

    return this.http.post(`${environment.apiUrl}api/service/fax/SendFax`, formData).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetCommunicationHistorySilent() {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    //const userID = user.UserID;
    const userID = this.selectedCaseOwnerId;
    // const uc = { company: company, userID: userID };
    const uc = { user: user, company: company, userID: userID };
    //return this.http.post(`${environment.apiUrl}api/service/fax/GetCommunicationHistorySilent`, uc).pipe(
    return this.http.get(`${environment.apiUrl}api/service/Data/GetCommunicationHistorySilent?userID=` + userID).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetFax(ID: number) {
    const markAsRead = true;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company, faxID: ID, markAsRead: markAsRead };
    return this.http.post(`${environment.apiUrl}api/service/fax/GetFax`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  CallCustomMethod(CarrierMemberId: number) {
    const method = 'GetMember';
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company, method: method, parameters: { CarrierMemberId: CarrierMemberId } };
    return this.http.post(`${environment.apiUrl}api/service/Data/CallCustomMethod`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        //console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetLocks(): any {
    const pl: any = {};
    pl.queueID = this.selectedQueueId;
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.post(`${environment.apiUrl}api/service/data/GetLocks`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        //console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetCaseLocks(caseID: any): any {
    const pl: any = {};
    pl.caseID = caseID;
      pl.queueID = this.selectedQueueId;
      pl.company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.post(`${environment.apiUrl}api/service/data/GetCaseLocks`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetAllLockedCases(): any {
    const pl: any = {};
      pl.queueID = this.selectedQueueId;
      pl.company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.post(`${environment.apiUrl}api/service/data/GetAllLockedCases`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  SetCaseLock(caseID, queueId) {
      const params = new HttpParams().set('caseID', caseID).set('queueID', queueId).set('company', this.webStorageService.getItemFromSessionStorage('company'));
    return this.http.get(`${environment.apiUrl}api/service/data/SetCaseLock`, { params: params }).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  SetDisableHeader(value) {
    this.DisableControls.next(value);
  }
  setReadOnlyCase(value) {
    this.isReadOnlyCase = value;
  }
  getReadOnlyCase() {
    return this.isReadOnlyCase;
  }
  setCaseDetailsLoaded(value) {
    this.CaseDetailsLoaded = value;
  }
  getLoadCaseCaseDetails() {
    return this.CaseDetailsLoaded;
  }
  SetVoicemailDetails(value) {
    this.VoiceMailDetails = value;
  }
  GetVoicemailDetails() {
    return this.VoiceMailDetails;
  }
  SetVoiceMailNav(value) {
    this.VoiceMailNav.next(value);
  }
  // SetQueue(queue: string) {
  //   this.queueSource.next(queue);
  // }
  setOutboundRecordUserID(value) {
    this.OutboundUserID = value;
  }
  getOutboundRecordUserID() {
    return this.OutboundUserID;
  }
  setisEscalatedCases(value) {
    this.isEscalatedCases = value;
  }
  getisEscalatedCases() {
    return this.isEscalatedCases;
  }
  setCallIDForTransferCases(value) {
    this.CallIDForTransferCases = value;
  }
  getCaseAssignerQueue(company): any {
    return this.http.get(`${environment.apiUrl}api/service/data/GetCaseAssignerQueues?company=${company}`).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getCaseAssignerAgent(queueID, caseID,company): any {
    return this.http
      .get(`${environment.apiUrl}api/service/data/GetCaseAssignerAgents?queueID=${queueID}&caseID=${caseID}&company=${company}`)
      .pipe(
        map(res => {
          this.loaderService.display(false);
          return res;
        }),
        catchError(Utils.handleHttpError)
      );
  }

  setQueueRoute(val: string) {
    this.queueRoute = val;
  }

  getQueueRoute() {
    return this.queueRoute;
  }
  SetVoicemailDetailsReply(value) {
    this.VoiceMailDetailsReply = value;
  }
  SetVoicemailDetailsReplyForChangeUser(value) {
    this.VoiceMailDetailsReplyForChangeUser = value;
  }
  getVoicemailDetailsReplyForChangeUser() {
    return this.VoiceMailDetailsReplyForChangeUser;
  }
  GetVoicemailDetailsReply() {
    return this.VoiceMailDetailsReply;
  }
  SetvoiceMailOnSearch(value) {
    this.voiceMailOnSearch.next(value);
  }
  getDependantFields(parameters: any): any {
    let pl: any = {};
    pl.caseID = parameters.caseID;
    pl.queueID = parameters.queueID;
    pl.activityID = parameters.activityID;
    pl.fieldID = parameters.fieldID;
    pl.fieldName = parameters.fieldName;
    pl.case = parameters.case;
    pl.company = parameters.company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetDependancyFieldMapping`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getDependantDataSource(parameters: any): any {
    let pl: any = {};
    pl.caseID = parameters.caseID;
    pl.queueID = parameters.queueID;
    pl.activityID = parameters.activityID;
    pl.fieldID = parameters.fieldID;
    pl.fieldName = parameters.fieldName;
    pl.parentValue = parameters.parentValue;
    pl.type = parameters.type;
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetDependantDataSource`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getSCIMappingQueueInfo(parameters: any): any {
    let pl: any = {};
    pl.Subject = parameters.Subject;
    pl.Category = parameters.Category;
    pl.Issue = parameters.Issue;
    pl.Method = parameters.Method;
    pl.Company = parameters.Company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetSCIMappingQueueInfo`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getParentDataSource(parameters: any): any {
    let pl: any = {};
    pl.queueID = parameters.queueID;
    pl.activityID = parameters.activityID;
    pl.fieldID = parameters.fieldID;
    pl.type = parameters.type;
    pl.currentID = parameters.currentID;
    pl.company = parameters.company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetParentDataSource`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getFieldValuesByCondition(parameters: any): any {
    let pl: any = {};
    pl.caseID = parameters.caseID;
    pl.queueID = parameters.queueID;
    pl.activityID = parameters.activityID;
    pl.fieldID = parameters.fieldID;
    pl.fieldName = parameters.fieldName;
    pl.case = parameters.case;
    pl.company = parameters.company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetFieldValueBasedOnConditions`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getTaskMenuAccordian() {
    return this.TaskMenuAccordian;
  }
  setTaskMenuAccordian(value) {
    this.TaskMenuAccordian = value;
  }
  getFindMemberFieldMappingValue(parameters: any): any {
    let pl: any = {};
    pl.caseID = parameters.caseID;
    pl.queueID = parameters.queueID;
    pl.activityID = parameters.activityID;
    pl.fieldName = parameters.fieldName;
    pl.userID = parameters.userID;
    pl.company = parameters.company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetFindMemberFieldValues`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  CreateExternalRecord(externalID: string) {
    let pl: any = {};
    const company = this.webStorageService.getItemFromSessionStorage('company');

    pl.externalID = externalID;
    pl.company = company;
    return this.http.post<any>(`${environment.apiUrl}api/service/data/CreateExternalRecord`, pl).pipe(
      map(res => {
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getSCIData(){
    let payload:any={}
    payload.method='GetSubjectCategoryIssues';
    payload.user=this.webStorageService.getItemFromSessionStorage('currentUser');
    payload.company=this.webStorageService.getItemFromSessionStorage('company');
    payload.parameters={};
    this.additionalinfoService.getAdditionalInfo(payload).subscribe(data=>{
      let finalSCIData = [];
      data.Response.Data?.forEach(sub=>{
        let subjectFields = {
          FieldOptionID: sub.ID,
          Name: sub.Label,
          Value: sub.Value,
          DisplayOrder: null,
          ScoreValue: null,
          FieldOptions: []
        };
        
        sub?.Options?.forEach(cat=>{
          let categoryFields = {
            FieldOptionID: cat.ID,
            Name: cat.Label,
            Value: cat.Value,
            DisplayOrder: null,
            ScoreValue: null,
            FieldOptions: []
          };
          
          cat?.Options?.forEach(iss=>{
            let issueFields = {
              FieldOptionID: iss.ID,
              Name: iss.Label,
              Value: iss.Value,
              DisplayOrder: null,
              ScoreValue: null,
              FieldOptions: [],
              Queue: iss.Queue,
              UserSegmentationID: iss.UserSegmentationID,
              CaseOutcomeEnabled: iss.OutcomeEnabled,
              AandGStatusEnabled: iss.AandGStatusEnabled,
              ComplainantEnabled: iss.ComplainantEnabled,
              ComplaintTypeEnabled: iss.ComplaintTypeEnabled,
              DisasterRelatedEnabled: iss.DisasterRelatedEnabled
            };
            categoryFields.FieldOptions.push(issueFields);
          });
           subjectFields.FieldOptions.push(categoryFields);
        });
       finalSCIData.push(subjectFields);
      });  
      this.flexStore.set('sciData', JSON.stringify(finalSCIData));
    });
  }

  // TODO: replace with real API call when endpoint is available
  getEmailData() {
    return this.http.get<any>('assets/email.json');
  }
  currentInteractionID(value?: number | null): number | null {
    if (value !== undefined) {
      this.CurrentID = value;
    }
    return this.CurrentID;
 }
}
